import { SQDCEventActionTypeInternalType } from "@/graphql";

export const PSC_EVENT_INTERNAL_TYPES = [
  SQDCEventActionTypeInternalType.A3,
  SQDCEventActionTypeInternalType.EightD,
] as const;
